import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleMacroActivity = {
  namespaced: true,

  state: {
    name: 'macro-activity',
    nextSeqCode: null,
    macroActivities: [],
  },

  mutations,
  getters,
  actions
}

export default moduleMacroActivity;